import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from '../storage/storage.service';

export type PrincipalColor = 'default' | 'purple' | 'orange' | 'blue';

@Injectable({
  providedIn: 'root',
})
export class ColorService {
  principalColor = signal<PrincipalColor>('default');

  private storage = inject(StorageService);

  async initColor() {
    const storedColor = (await this.storage.get('color')) as PrincipalColor | null;
    if (storedColor) {
      this.applyColorPalette(storedColor);
      this.principalColor.set(storedColor);
    } else {
      this.applyColorPalette('default');
    }
  }

  async setColor(color: PrincipalColor): Promise<void> {
    this.principalColor.set(color);
    await this.storage.set('color', color);
    this.applyColorPalette(color);
  }

  async setDefaultColor(): Promise<void> {
    this.setColor('default');
  }

  private applyColorPalette(color: PrincipalColor): void {
    const rootElement = document.documentElement;

    rootElement.classList.remove('palette-default', 'palette-purple', 'palette-orange', 'palette-blue');

    const className = `palette-${color}`;
    rootElement.classList.add(className);
  }
}
